import { Reveal } from "@/components/site/Motion";

const CARDS = [
  {
    title: "About Us",
    paras: [
      "With over 20 years of experience, Jimmie leads both the residential and commercial divisions at Seatech Aquariums. He specializes in designing, installing, and maintaining freshwater, saltwater, and reef aquariums.",
      "Jimmie is passionate about helping clients create beautiful, healthy aquariums and is known for his professionalism, attention to detail, and dependable service. He stays up to date with the latest industry techniques and technology to ensure every client receives the highest level of care.",
    ],
  },
  {
    title: "Expert Guidance",
    paras: [
      "Since 1999, Seatech Aquariums has been providing professional aquarium installation and maintenance throughout the Phoenix area. We're grateful for the trust our clients have placed in us over the years.",
      "We specialize in freshwater, saltwater, and reef aquariums. Whether it's a custom installation or ongoing maintenance, our goal is simple: provide reliable, honest, and professional service while keeping every aquarium looking its best.",
    ],
  },
  {
    title: "Community Engagement",
    paras: [
      "Seatech works on aquariums of all sizes, from 30 to 900 gallons. Whether you need a new installation or regular maintenance, we're here to provide reliable, professional service.",
      "We proudly serve the entire Phoenix area with aquarium installation, maintenance, water delivery, livestock, and equipment. Our work is backed by years of experience and a 6-month livestock guarantee for qualifying maintenance clients.",
    ],
  },
];

export const Showcase = () => (
  <section id="products" data-testid="products-section" className="relative py-10 lg:py-14">
    <div className="w-full max-w-[1860px] mx-auto px-5 lg:px-14">
      {/* Purple gradient banner */}
      <Reveal testid="why-banner">
        <div className="rounded-3xl px-10 lg:px-16 py-12 lg:py-16 bg-gradient-to-r from-[#5a3fe0] via-[#6d4ff0] to-white">
          <p className="font-body font-light text-base lg:text-lg text-white/85 mb-2">Why Choose</p>
          <h2 className="font-title text-5xl sm:text-6xl lg:text-7xl text-white">SeaTech?</h2>
        </div>
      </Reveal>

      <div className="mt-8 grid lg:grid-cols-2 gap-7 items-stretch">
        {/* Left: cards — horizontal slider on mobile/iPad, stacked on desktop */}
        <div className="flex items-stretch gap-4 overflow-x-auto snap-x snap-mandatory no-scrollbar pb-2 -mx-5 px-5 lg:mx-0 lg:px-0 lg:flex-col lg:gap-7 lg:overflow-visible" style={{ WebkitOverflowScrolling: "touch" }}>
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.1} testid={`why-card-${i}`} className="snap-center shrink-0 w-[86%] sm:w-[70%] lg:w-auto lg:shrink">
              <div className="h-full rounded-3xl bg-[#5a3fe0] p-8 sm:p-10 lg:p-14">
                <h3 className="font-title text-2xl sm:text-3xl lg:text-4xl text-white mb-6">{c.title}</h3>
                <div className="space-y-4">
                  {c.paras.map((p, j) => (
                    <p key={j} className="font-body font-light text-base lg:text-lg leading-relaxed text-white/85">
                      {p}
                    </p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Right: looping video container */}
        <Reveal delay={0.15} className="h-full" testid="why-video-wrap">
          <div className="h-full min-h-[420px] rounded-3xl overflow-hidden">
            <video
              className="h-full w-full object-cover"
              src="/media/why-tank.mp4"
              poster="/media/why-tank-poster.jpg"
              autoPlay
              loop
              muted
              playsInline
              data-testid="why-video"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
